import { useEffect, useState } from "react";
import styles from "./VisitorJugador.module.css";
import { getVisitorPublicaciones, getVisitorUser } from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import FeedVisitor from "../Feed/FeedVisitor.jsx";
import Otro from "../Otro/Otro.jsx";
import NavSecond from "../../sharedComponents/NavSecond/NavSecond.jsx";

const VistorNoJugador = ({
  inVisitor,
  noticias,
  publicacionView,
  seguir,
  isMobile,
}) => {
  const params = useParams();
  const id = params.id;
  const dispatch = useDispatch();
  const detailUser = useSelector((state) => state.dataVisitorUser);
  const publicaciones = useSelector((state) => state.visitorPublicaciones);
  const userPubliaciones = [];

  const [displayShow, setDisplayShow] = useState("MÉTRICAS");
  const [showNavSecond, setShowNavSecond] = useState(true);

  const handleDisplayShow = (display) => {
    setDisplayShow(display);
  };

  useEffect(() => {
    dispatch(getVisitorUser(id));
    dispatch(getVisitorPublicaciones(id));
  }, []);

  console.log("isMobile", isMobile);

  return (
    <>
      {isMobile ? (
        <div className={styles.container}>
          <div
            className={styles.leftContainer}
            style={{ display: displayShow === "MÉTRICAS" ? "flex" : "none" }}
          >
            <Otro user={detailUser} isVisitorBool={true} />
          </div>

          <div
            className={styles.subContainer}
            style={{ display: displayShow === "SOCIAL" ? "flex" : "none" }}
          >
            <FeedVisitor
              user={detailUser}
              publicaciones={publicaciones}
              userPubliaciones={userPubliaciones}
              inVisitor={inVisitor}
              noticias={noticias}
              publicacionView={publicacionView}
              seguir={seguir}
            />
          </div>

          {showNavSecond && (
            <div className={styles.navSecond}>
              <NavSecond
                handleDisplayShow={handleDisplayShow}
                displayShow={displayShow}
                user={detailUser}
                isVisitor={true}
              />
            </div>
          )}
        </div>
      ) : (
        <div className={styles.container}>
          <div className={styles.leftContainer}>
            <Otro user={detailUser} isVisitorBool={true} />
          </div>

          <div className={styles.subContainer}>
            <FeedVisitor
              user={detailUser}
              publicaciones={publicaciones}
              userPubliaciones={userPubliaciones}
              inVisitor={inVisitor}
              noticias={noticias}
              publicacionView={publicacionView}
              seguir={seguir}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default VistorNoJugador;
